import * as z from "zod";

export const LiveEsportMatch = z.object({
  livestreamStartTime: z.string().nullable(),
  livestreamEndTime: z.string().nullable(),
});

export type LiveEsportMatch = z.infer<typeof LiveEsportMatch>;
